/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ channel: NonNullable<unknown> }} Subtitle_Extract_Track_608Inputs */



/**
* | output |
* | --- |
* | "CEA-608 {channel}" |
*
* @param {Subtitle_Extract_Track_608Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_track_608 = /** @type {((inputs: Subtitle_Extract_Track_608Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Track_608Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीईए-608 __पीएच_0__")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
	return /** @type {LocalizedString} */ (`CEA-608 ${i?.channel}`)
});